import { useState, useEffect } from "react";
import { Spinner } from "react-bootstrap";
import axios from "axios";
import { toast } from "react-toastify";

const TYPE_UNIT = { weight: "kg", pieces: "pcs", pack: "pack" };

export default function ProductionProductsTab() {
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setLoading(true);
    axios.get("https://dailydish.in/api/admin/getFoodItems")
      .then(res => {
        if (res.data.data) {
          setProducts(res.data.data.filter(p => p.components && p.components.length > 0));
        }
      })
      .catch(() => toast.error("Failed to load products"))
      .finally(() => setLoading(false));
  }, []);

  return (
    <>
      <div className="d-flex justify-content-between align-items-center mb-3">
        <div>
          <h5 style={{ fontWeight: 700, marginBottom: 2 }}>Product Recipes</h5>
          <div style={{ fontSize: 13, color: "#888" }}>
            Food items with their cookable components — edit via Add Products page
          </div>
        </div>
      </div>

      <div style={{ background: "#fff", borderRadius: 12, border: "1px solid #eee", overflow: "hidden" }}>
        {loading ? (
          <div className="text-center py-5"><Spinner /></div>
        ) : products.length === 0 ? (
          <div className="text-center py-5" style={{ color: "#aaa" }}>
            <div style={{ fontSize: 40, marginBottom: 8 }}>🍱</div>
            <div style={{ fontWeight: 500 }}>No product recipes yet</div>
            <div style={{ fontSize: 13, marginTop: 4 }}>
              Go to Add Products and assign cookable components to a food item
            </div>
          </div>
        ) : products.map((p, i) => (
          <div key={p._id} style={{
            display: "flex", alignItems: "center", justifyContent: "space-between", gap: 16,
            padding: "14px 20px",
            borderBottom: i < products.length - 1 ? "1px solid #f0f0f0" : "none",
            background: "#fff", transition: "background 0.15s",
          }}
            onMouseEnter={e => e.currentTarget.style.background = "#fafafa"}
            onMouseLeave={e => e.currentTarget.style.background = "#fff"}
          >
            <div className="d-flex align-items-center gap-3" style={{ minWidth: 0 }}>
              {p.Foodgallery?.[0]?.image2
                ? <img src={p.Foodgallery[0].image2} alt={p.foodname} style={{ width: 52, height: 52, objectFit: "cover", borderRadius: 10, border: "1px solid #eee", flexShrink: 0 }} />
                : <div style={{ width: 52, height: 52, background: "#f0f0f0", borderRadius: 10, flexShrink: 0, display: "flex", alignItems: "center", justifyContent: "center", fontSize: 20 }}>🍽️</div>
              }
              <div style={{ minWidth: 0 }}>
                <div style={{ fontWeight: 600, fontSize: 15, marginBottom: 2 }}>{p.foodname}</div>
                {p.chefId && (
                  <div style={{ fontSize: 12, color: "#1D9E75", marginBottom: 4 }}>
                    👨‍🍳 {p.chefId.name}
                  </div>
                )}
                <div style={{ display: "flex", flexWrap: "wrap", gap: 4 }}>
                  {p.components.map((c, ci) => {
                    const item = c.cookableItemId;
                    if (!item) return null;
                    return (
                      <span key={ci} style={{ fontSize: 12, padding: "2px 10px", borderRadius: 20, background: "#f0f0f0", color: "#555", fontWeight: 500 }}>
                        {item.name} — {c.qty}{TYPE_UNIT[item.outputType] || ""}
                      </span>
                    );
                  })}
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </>
  );
}
